<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" icon="ios-add" v-if="isHavePermission('authorization:user:add')"
              @click="createUser(0, {})"
      >新增用户
      </Button>
      <Button icon="md-refresh" @click="refresh" style="margin-left: 10px">刷新</Button>
      <div class="authorization-header">
        <span>
          <label>用户名:</label>
          <vxe-input
              v-model="searchUserName"
              @keyup.enter.native="search"
              placeholder="请输入用户名"
          ></vxe-input>
        </span>
        <span>
          <label>手机号:</label>
          <vxe-input
              v-model="searchUserTel"
              @keyup.enter.native="search"
              placeholder="请输入手机号"
          ></vxe-input>
        </span>
        <span>
          <label>所属公司:</label>
          <Select v-model="searchCompanyId" placeholder="请选择公司" style="width: 200px;" clearable>
            <Option v-for="option in compData" :value="option.value"
                    :key="option.value">{{ option.label }}
            </Option>
          </Select>
        </span>
        <span>
          <label>部门:</label>
          <Select
              class="departSelect"
              v-model="searchDepart"
              multiple
              :default-label="[]"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              placeholder="请选择部门"
              style="width: 240px;"
              @on-open-change="selectDepart"
          >
            <Option v-for="option in searchDepartOptions" :value="option.id"
                    :key="option.id">{{ option.label }}
            </Option>
          </Select>
        </span>
        <Button type="primary" icon="ios-search" @click="search">搜索</Button>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          show-overflow
          ref="xGrid"
          max-height="560"
          border="none"
          align="center"
          :loading="loading"
          :data="userListData"
          :filter-config="{ remote: true }"
          @filter-change="filterChange"
      >
        <vxe-table-column field="id" title="序号" width="90"></vxe-table-column>
        <vxe-table-column
            field="username"
            title="用户名"
            width="150"
        ></vxe-table-column>
        <vxe-table-column
            field="mobilePhone"
            title="手机号"
            width="130"
        ></vxe-table-column>
        <vxe-table-column
            field="shortName"
            title="所属公司"
            width="200"
        >
          <template slot-scope="{ row }">
            <span>{{ row.shortName && row.shortName !== null ? row.shortName : row.companyName }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="departmentName"
            title="部门"
            width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="identityType"
            title="身份"
            width="130"
            :filters="[
            { label: '业务员', value: 0 },
            { label: '内部员工', value: 1 },
          ]"
            :filter-multiple="false"
        >
          <template slot-scope="{ row }">
            <span>{{ row.identityType | identityTypeMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="crtName"
            title="创建者"
            width="120"
        ></vxe-table-column>
        <vxe-table-column
            field="crtTime"
            title="加入时间"
            width="170"
        ></vxe-table-column>
        <vxe-table-column title="操作">
          <template slot-scope="{ row }">
            <span class="authorization-user-handle">
              <a v-if="isHavePermission('authorization:user:assignPms')" @click="assignPms(row.id, row.companyCode)">分配权限</a>
              <a v-if="isHavePermission('authorization:user:update')" @click="createUser(1, row)">编辑</a>
              <a
                  @click="showIsActive(row.id)"
                  v-if="row.isActive === 1 && isHavePermission('authorization:user:prohibit')"
                  style="color: #f00"
              >禁用</a
              >
              <a @click="prohibit(row.id, 1)"
                 v-if="row.isActive !== 1 && isHavePermission('authorization:user:prohibit')" style="color: #19be6b"
              >启用</a
              >
              <a @click="del(row.id)" v-if="isHavePermission('authorization:user:remove')">删除</a>
            </span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="handlePageChange"
      ></vxe-pager>
    </div>
    <vxe-modal
        v-model="isShowPermissions"
        title="分配权限"
        width="600"
        height="455"
        resize
    >
      <div class="permissions-main">
        <RadioGroup v-model="permissionsTab" type="button">
          <Radio label="用户权限"></Radio>
          <Radio label="用户角色"></Radio>
          <Radio label="公司权限"></Radio>
          <Radio label="数据共享"></Radio>
        </RadioGroup>
        <!-- Str 用户权限 -->
        <div v-show="permissionsTab === '用户权限'">
          <div class="permissions-con">
            <Tree :data="permissionsData"></Tree>
          </div>
          <div class="add-btn-box">
            <Button @click="closeShowPermissions">取消</Button>
            <Button status="primary">确定</Button>
          </div>
        </div>
        <!-- End 用户权限 -->
        <!-- Str 用户角色 -->
        <div v-show="permissionsTab === '用户角色'">
          <div class="permissions-con">
            <CheckboxGroup v-model="role">
              <span class="role-list" v-for="item in roleList" :key="item.id">
                <Checkbox :label="item.name"></Checkbox>
              </span>
            </CheckboxGroup>
            <!-- <Tree :data="roleList" show-checkbox></Tree> -->
          </div>
          <div class="add-btn-box">
            <Button @click="closeShowPermissions">取消</Button>
            <Button status="primary" @click="roleSubmit(curId)">确定</Button>
          </div>
        </div>
        <!-- End 用户角色 -->
        <!-- Str 公司权限 -->
        <div v-show="permissionsTab === '公司权限'">
          <div class="permissions-con">
            <CheckboxGroup v-model="company">
              <span
                  class="role-list"
                  v-for="item in companyList"
                  :key="item.companyID"
              >
                <Checkbox :label="item.companyName"></Checkbox>
              </span>
            </CheckboxGroup>
          </div>
          <div class="add-btn-box">
            <Button @click="closeShowPermissions">取消</Button>
            <Button status="primary" @click="saveCompanyPermission(curId)"
            >确定
            </Button>
          </div>
        </div>
        <!-- End 公司权限 -->
        <!-- Str 数据共享 -->
        <div v-show="permissionsTab === '数据共享'">
          <div class="permissions-con">
            <Button type="success" @click="addShareData" class="add-btn-data"
            >添加
            </Button>
            <dl class="clearfix" v-if="managerList.length > 0">
              <dt>内部员工:</dt>
              <CheckboxGroup v-model="checkManagerList">
                <dd v-for="item in managerList" :key="item.id">
                  <Checkbox :label="item.name"></Checkbox>
                </dd>
              </CheckboxGroup>
            </dl>
            <dl class="clearfix" v-if="salesmanList.length > 0">
              <dt>业务员:</dt>
              <CheckboxGroup v-model="checkSalesmanList">
                <dd v-for="item in salesmanList" :key="item.id">
                  <Checkbox :label="item.name"></Checkbox>
                </dd>
              </CheckboxGroup>
            </dl>
            <dl class="clearfix" v-if="departmentList.length > 0">
              <dt>部门:</dt>
              <CheckboxGroup v-model="checkDepartmentList">
                <dd v-for="item in departmentList" :key="item.id">
                  <Checkbox :label="item.name"></Checkbox>
                </dd>
              </CheckboxGroup>
            </dl>
            <dl class="clearfix" v-if="groupList.length > 0">
              <dt>角色:</dt>
              <CheckboxGroup v-model="checkGroupList">
                <dd v-for="item in groupList" :key="item.id">
                  <Checkbox :label="item.name"></Checkbox>
                </dd>
              </CheckboxGroup>
            </dl>
            <div
                v-if="
                managerList.length === 0 &&
                salesmanList.length === 0 &&
                departmentList.length === 0 &&
                groupList.length === 0
              "
                style="padding: 100px 0; text-align: center"
            >
              暂无数据
            </div>
          </div>
          <div class="add-btn-box">
            <Button @click="closeShowPermissions">取消</Button>
            <Button status="primary" @click="submitShareData">确定</Button>
          </div>
        </div>
        <!-- End 数据共享 -->
      </div>
    </vxe-modal>
    <vxe-modal
        v-model="isShowAddUser"
        :title="modalTitle"
        width="600"
        height="500"
        resize
    >
      <div class="permissions-main">
        <vxe-form
            ref="xForm"
            class="my-form2"
            title-align="right"
            title-width="100"
            :data="formData"
            :rules="formData.identityType === 0 ? formRules1 : formRules"
            @submit="submitEvent"
            @reset="cancelEvent"
        >
          <vxe-form-item title="用户名" field="username" span="24">
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.username"
                  placeholder="请输入名称"
                  clearable
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="手机号" field="mobilePhone" span="24">
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.mobilePhone"
                  v-number-only
                  placeholder="请输入手机号"
                  clearable
                  type="integer"
                  class="phoneInput"
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="所属公司" field="companyCode" span="24">
            <template>
              <vxe-select
                  v-model="formData.companyCode"
                  placeholder="请选择所属公司"
                  clearable
                  @change="changeCompany(formData.companyCode)"
                  @clear="clearCompany"
              >
                <vxe-option
                    v-for="(item, index) in dicByParentData"
                    :key="index"
                    :value="item.companyID"
                    :label="item.companyName"
                ></vxe-option>
              </vxe-select>
            </template>
          </vxe-form-item>
          <vxe-form-item title="所属部门" field="department" span="24">
            <template v-slot="scope">
              <vxe-select
                  v-model="formData.department"
                  placeholder="请选择所属部门"
                  clearable
                  @change="$refs.xForm.updateStatus(scope)"
              >
                <vxe-option
                    v-for="(item, index) in sleDepartmentData"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                ></vxe-option>
              </vxe-select>
            </template>
          </vxe-form-item>
          <vxe-form-item title="身份" field="identityType" span="24">
            <template v-slot="scope">
              <vxe-select
                  v-model="formData.identityType"
                  placeholder="请选择身份"
                  clearable
                  @change="$refs.xForm.updateStatus(scope)"
              >
                <vxe-option :value="0" label="业务员"></vxe-option>
                <vxe-option :value="1" label="内部员工"></vxe-option>
              </vxe-select>
            </template>
          </vxe-form-item>
          <vxe-form-item title="密码" field="password" span="24">
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.password"
                  placeholder="必填（6位字母和数字组合）"
                  clearable
                  type="password"
                  v-if="type === 0"
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
              <vxe-input
                  v-model="formData.password"
                  placeholder="必填（6位字母和数字组合）"
                  clearable
                  v-else
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="绑定APP账户" field="appId" span="24" v-if="type !== 0">
            <template>
              <vxe-pulldown ref="appDown" transfer>
                <template v-slot>
                  <vxe-input v-model="formData.appPhone" placeholder="请输入APP用户手机号"
                             @input="(file) =>inputEvent(file)" style="width: 460px"></vxe-input>
                </template>
                <template v-slot:dropdown>
                  <div class="chainId-dropdown">
                    <vxe-grid
                        border="none"
                        highlight-hover-row
                        auto-resize
                        height="auto"
                        :loading="appLoading"
                        :data="appData"
                        :columns="columns"
                        @cell-click="(file) => cellClick(file)"
                    ></vxe-grid>
                  </div>
                </template>
              </vxe-pulldown>
            </template>
          </vxe-form-item>
          <vxe-form-item align="center" span="24">
            <template v-slot>
              <vxe-button type="submit" status="primary">确定</vxe-button>
              <!-- <vxe-button type="submit" status="primary" @click="editEvent(formData)" v-else>确定</vxe-button> -->
              <vxe-button type="reset">取消</vxe-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </div>
    </vxe-modal>
    <vxe-modal
        v-model="isShowAddShareData"
        title="添加数据共享"
        width="600"
        height="455"
        resize
    >
      <Tabs v-model="tabsVal">
        <TabPane label="内部员工" name="name1">
          <vxe-table
              class="table-style"
              align="center"
              :data="managerListData"
              border="none"
              height="300"
              stripe
              ref="managerListTable"
              auto-resize
              @checkbox-all="managerSelectAllEvent"
              @checkbox-change="managerSelectChangeEvent"
          >
            <vxe-table-column type="checkbox" width="60"></vxe-table-column>
            <vxe-table-column field="name" title="员工姓名"></vxe-table-column>
          </vxe-table>
        </TabPane>
        <TabPane label="业务员" name="name2">
          <vxe-table
              class="table-style"
              align="center"
              :data="salesmanListData"
              border="none"
              height="300"
              ref="salesmanListTable"
              stripe
              auto-resize
              @checkbox-all="salesmanSelectAllEvent"
              @checkbox-change="salesmanSelectChangeEvent"
          >
            <vxe-table-column type="checkbox" width="60"></vxe-table-column>
            <vxe-table-column field="name" title="业务员"></vxe-table-column>
          </vxe-table>
        </TabPane>
        <TabPane label="部门" name="name3">
          <vxe-table
              class="table-style"
              align="center"
              :data="departmentListData"
              border="none"
              height="300"
              ref="departmentListTable"
              stripe
              auto-resize
          >
            <vxe-table-column type="checkbox" width="60"></vxe-table-column>
            <vxe-table-column field="name" title="部门"></vxe-table-column>
          </vxe-table>
        </TabPane>
        <TabPane label="角色" name="name4">
          <vxe-table
              class="table-style"
              align="center"
              :data="groupListData"
              border="none"
              height="300"
              ref="groupListTable"
              stripe
              auto-resize
          >
            <vxe-table-column type="checkbox" width="60"></vxe-table-column>
            <vxe-table-column field="name" title="角色"></vxe-table-column>
          </vxe-table>
        </TabPane>
        <vxe-input
            v-if="tabsVal === 'name1' || tabsVal === 'name2'"
            v-model="name"
            type="search"
            placeholder="姓名"
            @keyup.enter.native="searchDate"
            @search-click="searchDate"
            slot="extra"
        ></vxe-input>
      </Tabs>
      <div class="add-btn-box">
        <Button @click="closeShareData">取消</Button>
        <Button status="primary" @click="changeShareData">确定</Button>
      </div>
    </vxe-modal>
    <vxe-modal v-model="selectDepartModal" title="部门选择" width="900" height="700" resize>
      <tree-transfer ref="departModal" @close="selectDepartModal = false"
                     @selectDepart="afterSelectDepart"></tree-transfer>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import getAuthOrization from "@/mixin/getAuthOrization";
import TreeTransfer from "@/components/modal/TreeTransfer";

export default {
  components: {TreeTransfer},
  mixins: [getAuthOrization],
  data() {
    return {
      selectDepartModal: false,
      tabsVal: "name1",
      searchUserName: null,
      searchUserTel: null,
      loading: false,
      userListData: [],
      isShowPermissions: false,
      permissionsTab: "用户权限",
      permissionsData: [],
      isShowAddUser: false,
      managerRecords: [],
      salesmanRecords: [],
      formData: {
        id: null,
        username: null,
        mobilePhone: null,
        companyCode: null,
        identityType: null,
        password: null,
      },
      formRules1: {
        username: [{required: true, message: "请输入用户名"}],
        mobilePhone: [{max: 11, min: 11, message: "请输入正确手机号"}],
        identityType: [{required: true, message: "请选择身份"}],
        companyCode: [{required: true, message: "请选择所属公司"}],
        department: [{required: true, message: "请选择所属部门"}],
        password: [{required: true, message: "请输入密码"},
          {min: 6, message: "密码长度不少于6个字符"}],
      },
      formRules: {
        username: [{required: true, message: "请输入用户名"}],
        mobilePhone: [{max: 11, min: 11, message: "请输入正确手机号"}],
        identityType: [{required: true, message: "请选择身份"}],
        companyCode: [{required: true, message: "请选择所属公司"}],
        password: [{required: true, message: "请输入密码"}, {min: 6, message: "密码长度不少于6个字符"}],
      },
      dicByParentData: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      paramsObj: {
        orderBy: 2,
        page: 1,
        rows: 10
      },
      modalTitle: null,
      type: 0,
      rowObj: {},
      roleList: [],
      role: [],
      curId: null,
      companyList: [],
      company: [],
      managerList: [], // 内部员工
      salesmanList: [], // 业务员
      departmentList: [], // 部门
      groupList: [], // 角色
      checkManagerList: [],
      checkSalesmanList: [],
      checkDepartmentList: [],
      checkGroupList: [],
      isShowAddShareData: false,
      managerListData: [],
      salesmanListData: [],
      departmentListData: [],
      groupListData: [],
      companyId: null,
      ManagerListRecords: [],
      salesmanListRecords: [],
      departmentListRecords: [],
      groupListRecords: [],
      sleDepartmentData: [],
      name: null,
      compData: [],
      searchDepart: [],
      searchDepartOptions: [],
      toData: [],
      searchCompanyId: null,
      columns: [{field: "realName", title: "姓名"}, {field: "loginName", title: "手机号"}],
      appLoading: false,
      appData: [],
    };
  },
  directives: {
    numberOnly: {
      bind: function (e) {
        e.childNodes[0].handler = function () {
          e.childNodes[0].value = e.childNodes[0].value.replace(/\D+/, "");
        };
        e.childNodes[0].addEventListener("input", e.childNodes[0].handler);
      },
      unbind: function (e) {
        e.childNodes[0].removeEventListener("input", e.childNodes[0].handler);
      },
    },
  },
  mounted() {
    this.$bus.$on("用户管理", () => {
      this.getUserList();
      this.getDepartmentList();
    });
    this.getUserList();
    this.getDepartmentList();
  },
  activated() {

  },
  methods: {
    randomWord(code = '') {
      for (let i = 0; i < 6; i++) {
        let type = this.getRandom(1, 3)
        switch (type) {
          case 1:
            code += String.fromCharCode(this.getRandom(48, 57))// 数字
            break
          case 2:
            code += String.fromCharCode(this.getRandom(65, 90))// 大写字母
            break
          case 3:
            code += String.fromCharCode(this.getRandom(97, 122))// 小写字母
            break
        }
      }
      let regNum = /\d+/;
      let regString = /[a-zA-Z]+/;
      if (!regNum.test(code) && !regString.test(code)) {
        code = this.randomWord('');
      }
      return code
    },
    getRandom(min, max) {
      return Math.round(Math.random() * (max - min) + min)
    },
    inputEvent(val) {
      if (val && val !== '') {
        this.$refs.appDown.showPanel();
        this.queryAppList(val);
      }
    },
    cellClick({row}) {
      this.formData.appPhone = row.loginName;
      this.formData.userIdApp = row.userIdApp;
      this.$refs.appDown.hidePanel();
    },
    queryAppList(phone) {
      let data = {
        loginName: phone,
        page: 1,
        rows: 1000,
      }
      $api.gcdUser.queryRegisiterNumUserList
          .POST({
            data,
          })
          .then((response) => {
            if (response.status === 1) {
              let res = response.data;
              this.appData = res.rows;
            } else {
              this.$XModal.alert({
                message: response.message ? response.message : "接口异常",
                status: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    async getDepartmentList() {
      this.compData = [];
      let res = await $api.department.get('list');
      if (res.status === 1) {
        res.data.map(i => {
          this.compData.push({
            label: i.shortName ? i.shortName : i.name,
            value: i.id
          })
        })
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    selectDepart() {
      this.selectDepartModal = true;
      this.$refs.departModal.init(this.toData);
    },
    afterSelectDepart(data) {
      this.toData = JSON.parse(JSON.stringify(data));
      this.searchDepartOptions = [];
      this.searchDepart = [];
      data.map(i => {
        i.children.map(j => {
          this.searchDepartOptions.push(j);
          this.searchDepart.push(j.id);
        })
      })
      this.selectDepartModal = false;
    },
    managerSelectAllEvent({checked, records}) {
      if (checked) {
        this.managerRecords = records;
      } else {
        this.managerRecords = [];
      }
    },
    managerSelectChangeEvent({checked, row}) {
      if (checked) {
        this.managerRecords.push(row);
      } else {
        let key = this.managerRecords.indexOf(row);
        this.managerRecords.splice(key, 1);
      }
    },
    salesmanSelectAllEvent({checked, records}) {
      if (checked) {
        this.salesmanRecords = records;
      } else {
        this.salesmanRecords = [];
      }
    },
    salesmanSelectChangeEvent({checked, row}) {
      if (checked) {
        this.salesmanRecords.push(row);
      } else {
        let key = this.salesmanRecords.indexOf(row);
        this.salesmanRecords.splice(key, 1);
      }
    },
    searchDate() {
      if (this.tabsVal === 'name1') {
        this.querySaleManagerListModel1();
      } else if (this.tabsVal === 'name2') {
        this.querySaleManagerListModel2();
      }
    },
    refresh() {
      console.log(this.paramsObj, 'this.paramsObj')
      this.queryUserListByObj(this.paramsObj);
    },
    resetFormData() {
      this.formData = {
        username: "",
        mobilePhone: "",
        companyCode: null,
        identityType: null,
        password: null,
        department: null,
      };
    },
    filterChange({column, property, values, datas, filters, $event}) {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.paramsObj.page = this.page.currentPage;
      this.paramsObj.rows = this.page.pageSize;
      this.paramsObj.identityType = values[0];
      this.queryUserListByObj(this.paramsObj);
    },
    closeShowPermissions() {
      this.isShowPermissions = false;
    },
    async getDepartmentInfo(id) {
      let url = `listDepartment/${id}`;
      let res = await $api.department.get(url);
      if (res.status === 1) {
        this.sleDepartmentData = res.data;
        // this.formData.department = null;
        // console.log( this.formData.department, ' this.formData.department')
      }
    },
    changeCompany(id) {
      this.formData.department = null;
      if (id !== null) {
        this.getDepartmentInfo(id);
      }
    },
    clearCompany() {
      this.sleDepartmentData = [];
    },
    async getDicByParentList() {
      let response = await $api.user.request("queryCompanyPermission");
      if (response.status == 1) {
        this.dicByParentData = response.data;
      }
      // $api.other.getDicByParentModel
      //   .GET({
      //     params: {
      //       page: 1,
      //       rows: 10,
      //     },
      //   })
      //   .then((res) => {
      //     this.dicByParentData = res.data;
      //   });
    },
    async createUser(type, obj) {
      // 新增用户
      // console.log(obj, "row");
      this.isShowAddUser = true;
      this.type = type;
      this.sleDepartmentData = [];
      this.getDicByParentList();
      this.$refs.xForm.clearValidate();
      if (type === 0) {
        this.modalTitle = "新增用户";
        this.formData = {
          id: null,
          username: null,
          mobilePhone: null,
          companyCode: null,
          department: null,
          identityType: null,
          password: null,
        };
        this.formData.password = this.randomWord('');
      } else {
        if (obj.companyCode) {
          this.getDepartmentInfo(obj.companyCode);
        }
        this.modalTitle = "编辑用户";
        if (obj.companyCode === -1) {
          this.formData = {
            id: obj.id,
            username: obj.username,
            mobilePhone: obj.mobilePhone,
            companyCode: null,
            department: null,
            identityType: obj.identityType,
            password: "******",
            appPhone: obj.loginName,
            userIdApp: obj.userIdApp,
          };
        } else {
          this.formData = {
            id: obj.id,
            username: obj.username,
            mobilePhone: obj.mobilePhone,
            companyCode: obj.companyCode,
            department: obj.departmentId,
            identityType: obj.identityType,
            password: "******",
            appPhone: obj.loginName,
            userIdApp: obj.userIdApp,
          };
        }

        // this.formData.id = obj.id;
        // this.formData.username = obj.username;
        // this.formData.mobilePhone = obj.mobilePhone;
        // this.formData.companyCode = obj.companyCode;
        // this.formData.department = obj.departmentId;
        // this.formData.identityType = obj.identityType;
        // this.formData.password = "******";
      }
    },
    async editEvent(obj) {
      let paramsObj = {};
      if (obj.id !== null) {
        paramsObj.id = obj.id;
      }
      if (obj.username !== null) {
        paramsObj.username = obj.username.trim();
      }
      if (obj.mobilePhone !== null) {
        paramsObj.mobilePhone = obj.mobilePhone.trim();
      }
      if (obj.companyCode !== null) {
        paramsObj.companyCode = obj.companyCode;
      } else {
        paramsObj.companyCode = -1;
      }
      if (obj.department !== null) {
        paramsObj.department = obj.department;
      } else {
        paramsObj.department = -1;
      }

      if (obj.identityType !== null) {
        paramsObj.identityType = obj.identityType;
      }
      // 后端要求密码置空 传888999
      if (obj.password == '') {
        paramsObj.password = '888999';
      } else if (obj.password !== "******") {
        paramsObj.password = obj.password;
      }
      let data = {
        id: this.formData.id,
        userIdApp: !this.formData.appPhone || this.formData.appPhone === '' ? null : this.formData.userIdApp
      };
      $api.authorization.bindUserIdManager
          .POST({
            data,
          })
          .then((res) => {
            if (res.status === 1) {
              this.updateForm(obj, paramsObj);
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          });
    },
    async updateForm(obj, paramsObj) {
      let url = `update/${obj.id}`;
      let res = await $api.authorization.request(url, paramsObj);
      if (res.status === 1) {
        this.$XModal.message({message: "修改成功！"});
        // console.log(this.formData.department, 'this.formData.department')
        let secId = null;
        if (
            this.formData.department === null &&
            this.formData.companyCode === null
        ) {
          secId = -1;
        } else if (
            this.formData.department === null &&
            this.formData.companyCode !== null
        ) {
          secId = this.formData.companyCode;
        } else {
          secId = this.formData.department;
        }
        this.addDepartment(obj.id, secId);
        this.isShowAddUser = false;
        this.queryUserListByObj(this.paramsObj);
        this.resetFormData();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    getUserList() {
      this.loading = true;
      $api.authorization.userListModel
          .GET({
            params: {
              orderBy: 2,
              page: this.page.currentPage,
              rows: this.page.pageSize,
            },
          })
          .then((res) => {
            if (res.status === 1) {
              this.page.totalResult = res.data.total;
              this.userListData = res.data.rows;
              this.loading = false;
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          });
    },
    search() {
      // 搜索
      this.searchUserName !== null
          ? (this.paramsObj.userName = this.searchUserName)
          : "";
      this.searchUserTel !== null
          ? (this.paramsObj.phoneNum = this.searchUserTel)
          : "";
      this.paramsObj.companyId = this.searchCompanyId;
      this.paramsObj.departmentIds = this.searchDepart;
      this.paramsObj.page = 1;
      this.page.currentPage = 1;
      this.paramsObj.rows = this.page.pageSize;
      this.loading = true;
      this.queryUserListByObj(this.paramsObj);
    },
    queryUserListByObj(obj) {
      this.loading = true;
      $api.authorization.userListModel
          .GET({
            params: obj,
          })
          .then((res) => {
            this.page.totalResult = res.data.total;
            this.userListData = res.data.rows;
            this.loading = false;
          });
    },
    handlePageChange(e) {
      // 分页
      if (this.paramsObj) {
        this.paramsObj.page = e.currentPage;
        this.paramsObj.rows = e.pageSize;
        this.queryUserListByObj(this.paramsObj);
      } else {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.getUserList();
      }
    },
    assignPms(id, companyId) {
      // 分配权限
      this.companyId = companyId;
      this.role = [];
      this.company = [];
      this.checkManagerList = [];
      this.checkSalesmanList = [];
      this.checkDepartmentList = [];
      this.checkGroupList = [];
      this.ManagerListRecords = [];
      this.salesmanListRecords = [];
      this.departmentListRecords = [];
      this.groupListRecords = [];
      this.isShowPermissions = true;
      this.curId = id;
      this.permissionsTab = "用户权限";
      this.getAuthOrization(id);
      this.getRoleList(id);
      this.getCompanyList(id);
      this.getShareList(id);
    },
    getAuthOrization(id) {
      this.permissionsData = [];
      // 获取用户权限
      $api.authorization.authorityTreeModel
          .GET({
            params: {
              userId: id,
            },
          })
          .then((res) => {
            if (res.status === 1) {
              let arr = [];
              if (res.data && res.data.length > 0) {
                arr = res.data.map((item) => {
                  return {
                    id: item.id,
                    parentId: item.parentId,
                    title: item.title,
                    children: item.children,
                  };
                });
                arr.push({id: -1, parentId: null, title: null, orderNum: 0});
                arr = arr.sort((a, b) => a.orderNum - b.orderNum);
                // console.log(arr, "aaa");
                const idMapping = arr.reduce((acc, el, i) => {
                  acc[el.id] = i;
                  return acc;
                }, {});
                let root;
                arr.forEach((el) => {
                  // 判断根节点
                  if (el.parentId === null) {
                    root = el;
                    return;
                  }
                  // 用映射表找到父元素
                  const parentEl = arr[idMapping[el.parentId]];
                  // 把当前元素添加到父元素的`children`数组中
                  if (parentEl) {
                    parentEl.children = [...(parentEl.children || []), el];
                  }
                });
                this.permissionsData = [...root.children];
                console.log(this.permissionsData, "permissionsData");
              }
            }
          });
    },
    getRoleList(id) {
      // 获取角色菜单列表
      $api.authorization.groupListModel
          .GET()
          .then((res) => {
            if (res.status === 1) {
              this.roleList = res.data;
            }
          })
          .then(() => {
            this.getHaveRoleList(id);
          });
    },
    getHaveRoleList(id) {
      // 获取该角色拥有得菜单权限
      $api.authorization.queryUserGroupListModel
          .GET({
            params: {
              userId: id,
            },
          })
          .then((res) => {
            if (res.status === 1) {
              if (res.data && res.data.length > 0) {
                res.data.forEach((item) => {
                  this.role.push(item.name);
                });
              }
            }
          });
    },
    roleSubmit(id) {
      let arr = [];
      this.role.forEach((v) => {
        let curItem = this.roleList.filter((item) => {
          return item.name === v;
        });
        arr.push(curItem[0].id);
      });
      let groupString = arr.toString();
      $api.authorization.modifyUserGroupModel
          .GET({
            params: {
              userId: id,
              groups: groupString,
            },
          })
          .then((res) => {
            if (res.status === 1) {
              this.$XModal.message({message: "修改成功！"});
              this.isShowPermissions = false;
              this.queryUserListByObj(this.paramsObj);
            }
          });
    },
    async getCompanyList(id) {
      let res = await $api.authorization.get("queryCompanyPermission", {
        userId: id,
      });
      if (res.status === 1) {
        this.companyList = res.data;
        this.companyList.forEach((v) => {
          v.hasPermission === 1 ? this.company.push(v.companyName) : "";
        });
      }
    },
    async saveCompanyPermission(id) {
      let arr = [];
      if (this.company && this.company.length > 0) {
        this.company.forEach((v) => {
          let curItem = this.companyList.filter((item) => {
            return item.companyName === v;
          });
          arr.push(curItem[0].companyID);
        });
      }
      let res = await $api.authorization.get("saveCompanyPermission", {
        companyIds: arr,
        userId: id,
      });
      if (res.status === 1) {
        this.$XModal.message({message: "修改成功"});
        this.isShowPermissions = false;
      }
    },
    async prohibit(id, type) {
      // 1:禁用 ;  0: 激活
      let url = `update/${id}`;
      let txt = type === 1 ? "启用成功" : "禁用成功";
      let obj = {
        id,
        isActive: type,
      };
      let res = await $api.authorization.request(url, obj);
      if (res.status === 1) {
        this.$XModal.message({message: txt});
        this.queryUserListByObj(this.paramsObj);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    showIsActive(id) {
      this.$XModal
          .confirm(`此操作将禁用该用户，是否继续？`, "是否禁用该用户？")
          .then((type) => {
            // this.$XModal.message({ message: `点击了 ${type}` });
            if (type === "confirm") {
              this.prohibit(id, 0);
            }
          });
    },
    del(id) {
      // 删除
      this.$XModal
          .confirm(`此操作将永久删除该用户，是否继续？`, "是否删除该用户？")
          .then((type) => {
            // this.$XModal.message({ message: `点击了 ${type}` });
            if (type === "confirm") {
              this.queryDelUser(id);
            }
          });
    },
    async queryDelUser(id) {
      let url = `remove/${id}`;
      let res = await $api.authorization.get(url, {
        id,
      });
      if (res.status === 1) {
        this.$XModal.message({message: "删除成功！"});
        this.queryUserListByObj(this.paramsObj);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
      // $api.authorization.delUserModel
      //   .GET({
      //     params: { id },
      //   })
      //   .then((res) => {
      //     if (res.status === 1) {
      //       this.$XModal.message({ message: "删除成功！" });
      //       this.getUserList();
      //     }
      //     console.log(res);
      //   });
    },
    submitEvent() {
      let reg = /((^[0-9]{6,})|(^[a-z]{6,})|(^[A-Z]{6,}))$/;
      if (reg.test(this.formData.password)) {
        this.$XModal.alert({
          message: "密码强度过低，请重新设置密码",
          status: "error",
        });

        return;
      }
      if (this.type === 0) {
        this.createNewUser();
      } else {
        this.editEvent(this.formData);
      }
    },
    createNewUser() {
      let obj = {};
      obj.username = this.formData.username.trim();
      obj.mobilePhone = this.formData.mobilePhone ? this.formData.mobilePhone.trim() : null;
      obj.companyCode = this.formData.companyCode;
      obj.identityType = this.formData.identityType;
      obj.password = this.formData.password;

      $api.authorization.addUserModel
          .POST({
            data: obj,
          })
          .then((res) => {
            if (res.status === 1) {
              this.$XModal.message({message: "添加成功！"});
              let secId = null;
              if (
                  this.formData.department === null &&
                  this.formData.companyCode === null
              ) {
                secId = -1;
              } else if (
                  this.formData.department === null &&
                  this.formData.companyCode !== null
              ) {
                secId = this.formData.companyCode;
              } else {
                secId = this.formData.department;
              }
              this.addDepartment(res.data.id, secId);
              // console.log(res, 'resres')
              this.isShowAddUser = false;
              this.resetFormData();
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          });
    },
    bindUserIdManager() {

    },
    async addDepartment(id, departmentId = 0) {
      let url = `userUpdateCompany/${id}/${departmentId}`;
      let res = await $api.departmentUser.get(url);
      if (res.status === 1) {
        this.queryUserListByObj(this.paramsObj);
      }
    },
    cancelEvent() {
      this.isShowAddUser = false;
    },
    async getShareList(id) {
      this.managerList = [];
      this.salesmanList = []; // 业务员
      this.departmentList = []; // 部门
      this.groupList = []; // 角色

      let url = `getSharing/${id}`;
      let res = await $api.dataSharing.get(url);
      if (res.status === 1) {
        if (res.data.managerList && res.data.managerList.length > 0) {
          this.managerList = res.data.managerList;
          this.checkManagerList = this.managerList.map((v) => v.name);
        }
        if (res.data.salesmanList && res.data.salesmanList.length > 0) {
          this.salesmanList = res.data.salesmanList;
          this.checkSalesmanList = this.salesmanList.map((v) => v.name);
        }
        if (res.data.departmentList && res.data.departmentList.length > 0) {
          this.departmentList = res.data.departmentList;
          this.checkDepartmentList = this.departmentList.map((v) => v.name);
        }
        if (res.data.groupList && res.data.groupList.length > 0) {
          this.groupList = res.data.groupList;
          this.checkGroupList = this.groupList.map((v) => v.name);
        }
      }
    },
    addShareData() {
      this.isShowAddShareData = true;
      this.tabsVal = "name1";
      if (this.managerList.length > 0) {
        this.managerRecords = [...this.managerList];
      }
      if (this.salesmanList.length > 0) {
        this.salesmanRecords = [...this.salesmanList];
      }
      if (this.departmentList.length > 0) {
        this.departmentListRecords = [...this.departmentList];
      }
      if (this.groupList.length > 0) {
        this.groupListRecords = [...this.groupList];
      }
      this.getAddData();
    },
    closeShareData() {
      this.isShowAddShareData = false;
      this.managerRecords = [];
      this.salesmanRecords = [];
    },
    async querySaleManagerListModel1() {
      $api.authorization.querySaleManagerListModel
          .GET({
            params: {
              identityType: 1,
              page: 1,
              rows: 500,
              userName: this.name
            },
          })
          .then((res) => {
            this.managerListData = res.data.rows;
            this.managerListData.map((i) => {
              this.managerRecords.map((j) => {
                if (parseInt(i.id) === j.id) {
                  this.$refs.managerListTable.setCheckboxRow(i, true);
                }
              });
            });
          });
    },
    querySaleManagerListModel2() {
      $api.authorization.querySaleManagerListModel
          .GET({
            params: {
              identityType: 0,
              page: 1,
              rows: 500,
              userName: this.name
            },
          })
          .then((res) => {
            this.salesmanListData = res.data.rows;
            this.salesmanListData.map((i) => {
              this.salesmanList.map((j) => {
                if (parseInt(i.id) === j.id) {
                  this.$refs.salesmanListTable.setCheckboxRow(i, true);
                }
              });
            });
          });
    },
    async getAddData() {
      this.querySaleManagerListModel1();
      this.querySaleManagerListModel2();
      let url = `listDepartment/${this.companyId}`;
      let res = await $api.department.get(url);
      if (res.status === 1) {
        this.departmentListData = res.data;
        let arr = [];
        this.departmentList.forEach((v) => {
          let i = this.departmentListData.findIndex((item) => {
            return item.id == v.id;
          });
          arr.push(this.departmentListData[i]);
        });
        this.$refs.departmentListTable.setCheckboxRow(arr, true);
      }
      $api.authorization.groupListModel.GET().then((res) => {
        this.groupListData = res.data;
        let arr = [];
        this.groupList.forEach((v) => {
          let i = this.groupListData.findIndex((item) => {
            return item.id == v.id;
          });
          arr.push(this.groupListData[i]);
        });
        this.$refs.groupListTable.setCheckboxRow(arr, true);
      });
    },
    changeShareData() {
      this.managerList = [...this.managerRecords];
      this.salesmanList = [...this.salesmanRecords];
      let departmentListRecords = this.$refs.departmentListTable.getCheckboxRecords();
      this.departmentList = [...departmentListRecords];
      let groupListRecords = this.$refs.groupListTable.getCheckboxRecords();
      this.groupList = [...groupListRecords];
      this.checkManagerList = [];
      this.managerRecords.forEach((v) => {
        this.checkManagerList.push(v.name);
        this.checkManagerList = [...new Set(this.checkManagerList)];
      });
      this.checkSalesmanList = [];
      this.salesmanRecords.forEach((v) => {
        this.checkSalesmanList.push(v.name);
        this.checkSalesmanList = [...new Set(this.checkSalesmanList)];
      });
      this.checkDepartmentList = [];
      departmentListRecords.forEach((v) => {
        this.checkDepartmentList.push(v.name);
        this.checkDepartmentList = [...new Set(this.checkDepartmentList)];
      });
      this.checkGroupList = [];
      groupListRecords.forEach((v) => {
        this.checkGroupList.push(v.name);
        this.checkGroupList = [...new Set(this.checkGroupList)];
      });

      this.closeShareData();
    },
    async submitShareData() {
      let url = `saveSharing/${this.curId}`;
      let sharingVO = {
        departmentList: [],
        groupList: [],
        managerList: [],
        salesmanList: [],
      };
      // console.log(this.checkManagerList, 'this.checkManagerList')
      this.checkManagerList.forEach((item) => {
        let findObj = this.managerList.find((v) => {
          return v.name === item;
        });
        sharingVO.managerList.push(findObj);
      });
      this.checkGroupList.forEach((item) => {
        let findObj = this.groupList.find((v) => {
          return v.name === item;
        });
        sharingVO.groupList.push(findObj);
      });
      this.checkDepartmentList.forEach((item) => {
        let findObj = this.departmentList.find((v) => {
          return v.name === item;
        });
        sharingVO.departmentList.push(findObj);
      });
      this.checkSalesmanList.forEach((item) => {
        let findObj = this.salesmanList.find((v) => {
          return v.name === item;
        });
        sharingVO.salesmanList.push(findObj);
      });

      let res = await $api.dataSharing.post(url, sharingVO);
      if (res.status === 1) {
        this.$XModal.message({message: "修改成功！"});
        this.queryUserListByObj(this.paramsObj);
        this.isShowPermissions = false;
      }
    },
  },
};
</script>

<style>
.authorization-user-handle a {
  margin: 0 10px;
  color: #000;
}

.permissions-main {
  height: 370px;
  width: 100%;
}

.permissions-con {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  height: 280px;
  margin-bottom: 10px;
  overflow-y: scroll;
}

.permissions-main .add-btn-box {
  width: 100%;
}

.role-list {
  display: block;
  width: 100%;
  height: 24px;
  line-height: 24px;
  overflow: hidden;
  margin: 3px 0;
}

.permissions-con {
  position: relative;
}

.permissions-con dl {
  margin-bottom: 20px;
  width: 100%;
  position: relative;
  padding-left: 110px;
  min-height: 20px;
}

.permissions-con dt {
  width: 100px;
  float: left;
  text-align: right;
  padding-right: 20px;
  box-sizing: border-box;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.permissions-con .add-btn-data {
  position: absolute;
  right: 0px;
  top: 10px;
  z-index: 9999;
}

.phoneInput .vxe-input--suffix {
  right: 0.5rem !important;
}

.phoneInput .vxe-input--extra-suffix {
  display: none;
}

.departSelect .ivu-select-dropdown {
  display: none;
}

.departSelect .ivu-select-selection .ivu-tag .ivu-icon-ios-close {
  display: none;
}

.chainId-dropdown {
  width: 400px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
  position: relative;
}
</style>